import { hoursToMs, sessionAtom } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { gamificationApi } from '../api';

export const useGamificationBehaviorsQuery = () => {
	const sessionTokens = useAtomValue(sessionAtom);

	return useQuery({
		enabled: !!sessionTokens?.authToken,
		queryFn: async () =>
			(await gamificationApi).fetchGamificationBehaviors({
				'details[]': ['behaviorTranslations'],
				limit: 40
			}),
		queryKey: ['gamification', 'behaviors'],
		select: res => res.data ?? [],
		staleTime: hoursToMs(24)
	});
};
